import { apiCall } from "../../lib/supabase";

export const getCategories = async () => {
  const response = await apiCall
    .from("category")
    .select("id,name,sequence")
    .order("sequence", { ascending: true });
  return response;
};
